import React from "react";  
import { 
  FaBox,
  FaTruck,
  FaIndustry,
  FaStore,
  FaCogs,
  FaChartLine,
  FaArrowRight,
  FaCheck,
} from "react-icons/fa";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ChallengesImage from "../assets/fmcg-challenges.webp";
import heroBg from "../assets/fmcg.jpg";  


const FMCGIndustry = () => {
  const services = [
    {
      icon: FaBox,
      title: "Product Manufacturing",
      description:
        "End-to-end production support for packaged foods, beverages, and daily essentials.",
      features: [
        "Efficient Production Planning",
        "Quality Control",
        "Batch Tracking",
        "Demand Forecasting",
      ],
      color: "from-blue-500 to-cyan-500",
      iconColor: "text-white",
    },
    {
      icon: FaTruck,
      title: "Supply Chain & Distribution",
      description:
        "Seamless transportation, warehouse management, and last-mile delivery optimization.",
      features: [
        "Logistics Automation",
        "Cold Chain Tracking",
        "Smart Routing",
        "Distributor Management",
      ],
      color: "from-purple-500 to-fuchsia-500",
      iconColor: "text-white",
    },
    {
      icon: FaStore,
      title: "Retail & Merchandising",
      description:
        "Boost retail presence with smart shelving, inventory visibility, and POS integrations.",
      features: [
        "Retail Insights",
        "Promotion Planning",
        "Stock Replenishment",
        "Outlet Performance Tracking",
      ],
      color: "from-orange-500 to-amber-500",
      iconColor: "text-white",
    },
    {
      icon: FaIndustry,
      title: "Packaging & Processing",
      description:
        "Advanced food processing, labeling automation, and quality packaging solutions.",
      features: [
        "Automated Packaging",
        "Barcode & Labeling",
        "Damage Tracking",
        "Sustainability Insights",
      ],
      color: "from-green-500 to-emerald-500",
      iconColor: "text-white",
    },
    {
      icon: FaCogs,
      title: "Operational Efficiency",
      description:
        "Digitizing FMCG operations with workflow automation and production intelligence.",
      features: [
        "Automation Tools",
        "Resource Planning",
        "Process Optimization",
        "Predictive Maintenance",
      ],
      color: "from-red-500 to-rose-500",
      iconColor: "text-white",
    },
    {
      icon: FaChartLine,
      title: "Sales & Marketing Growth",
      description:
        "Enhance brand visibility with market analytics, social campaigns, and performance tracking.",
      features: [
        "Sales Dashboards",
        "Consumer Behavior Insights",
        "Campaign Tracking",
        "Channel Sales Optimization",
      ],
      color: "from-teal-500 to-cyan-500",
      iconColor: "text-white",
    },
  ];


  const segments = [
    {
      category: "Manufacturing Segments",
      items: [
        "Food Processing Units",
        "Beverage Manufacturing",
        "Dairy & Packaged Goods",
        "Snacks & Confectionery",
        "Frozen Foods",
        "Personal Care Products",
      ],
      icon: FaIndustry,
      iconColor: "text-white",
    },
    {
      category: "Retail & Distribution",
      items: [
        "Supermarkets",
        "Distributors",
        "Wholesale Dealers",
        "Retail Chains",
        "E-commerce FMCG",
        "Modern Trade & General Stores",
      ],
      icon: FaStore,
      iconColor: "text-white",
    },
    {
      category: "Logistics & Operations",
      items: [
        "Cold Storage",
        "Fleet Management",
        "Warehouse Operations",
        "Demand Forecasting",
        "Supply Chain Tracking",
        "Procurement Management",
      ],
      icon: FaTruck,
      iconColor: "text-white",
    },
  ];

  return (
    <div className="bg-gradient-to-br from-gray-50 to-gray-100">
      <Navbar />
      <div className="min-h-screen">

        {/* HERO SECTION */}
<div
  className="relative bg-cover bg-center bg-no-repeat text-white py-24 overflow-hidden"
  style={{ backgroundImage: `url(${heroBg})` }}
>
  <div className="absolute inset-0 bg-black/60"></div>

  <div className="container mx-auto px-6 relative z-10 text-center">

    <h1 className="text-6xl font-bold text-white mb-6 pb-3">
      FMCG Industry
    </h1>

    <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-10">
      Empowering FMCG brands with digital innovation, supply chain efficiency, and retail intelligence.
    </p>
  </div>
</div>


        {/* SERVICES SECTION */}
        <div className="pt-10 pb-20 bg-gradient-to-br from-gray-900 to-black text-white relative">
          <div className="container mx-auto px-6 relative">
            <div className="text-center mb-16">
              <h2 className="text-5xl font-bold text-white mb-6">
                FMCG Services
              </h2>
              <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
                Smart digital solutions crafted for the fast-moving consumer goods industry
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service, index) => (
                <div
                  key={index}
                  className="group bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-8 hover:shadow-2xl transition-all duration-500 border border-gray-700 hover:border-blue-500/50 hover:-translate-y-2"
                >
                  <div className="flex items-center gap-4 mb-6">
                    <div className="bg-gradient-to-r from-cyan-500 to-blue-500 p-3 rounded-2xl shadow-lg flex items-center justify-center">
                      <service.icon className={`text-2xl ${service.iconColor}`} />
                    </div>
                    <h3 className="text-2xl font-bold">{service.title}</h3>
                  </div>

                  <p className="text-gray-300 leading-relaxed text-lg mb-6">
                    {service.description}
                  </p>

                  <div className="space-y-3">
                    {service.features.map((feature, i) => (
                      <div key={i} className="flex items-center">
                        <div className="bg-cyan-300/20 p-1 rounded-lg mr-3">
                          <FaCheck className="text-blue-400 text-sm" />
                        </div>
                        <span className="text-gray-300">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>

        {/* NEW 2×2 CHALLENGES GRID SECTION */}
        <div className="pt-10 pb-20 bg-white">
          <div className="container mx-auto px-6">
            <h2 className="text-5xl font-bold text-gray-900 text-center mb-16">
              Challenges Faced by the FMCG Industry
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

              {/* LEFT — 4 CARDS */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

                {/* CARD 01 */}
                <div className="bg-white shadow-xl border border-gray-200 rounded-2xl p-6 hover:shadow-2xl transition">
                  <div className="text-4xl font-bold bg-gradient-to-r from-cyan-500 to-blue-500 bg-clip-text text-transparent mb-4">
                    01
                  </div>
                  <h3 className="font-bold text-gray-900 mb-2">
                    Complex Multi-tier Distribution
                  </h3>
                  <p className="text-gray-600">
                    Track products across manufacturer → distributor → retailer with real-time visibility and automated reconciliations.
                  </p>
                </div>

                {/* CARD 02 */}
                <div className="bg-white shadow-xl border border-gray-200 rounded-2xl p-6 hover:shadow-2xl transition">
                  <div className="text-4xl font-bold bg-gradient-to-r from-cyan-500 to-blue-500 bg-clip-text text-transparent mb-4">
                    02
                  </div>
                  <h3 className="font-bold text-gray-900 mb-2">
                    Demand & Supply Volatility
                  </h3>
                  <p className="text-gray-600">
                    Seasonal spikes and promotions cause stockouts or overstock — predictive analytics help balance inventory.
                  </p>
                </div>

                {/* CARD 03 */}
                <div className="bg-white shadow-xl border border-gray-200 rounded-2xl p-6 hover:shadow-2xl transition">
                  <div className="text-4xl font-bold bg-gradient-to-r from-cyan-500 to-blue-500 bg-clip-text text-transparent mb-4">
                    03
                  </div>
                  <h3 className="font-bold text-gray-900 mb-2">
                    Counterfeiting & Quality Issues
                  </h3>
                  <p className="text-gray-600">
                    Protect brand trust with QR authentication, batch traceability, and automated QC checkpoints.
                  </p>
                </div>

                {/* CARD 04 */}
                <div className="bg-white shadow-xl border border-gray-200 rounded-2xl p-6 hover:shadow-2xl transition">
                  <div className="text-4xl font-bold bg-gradient-to-r from-cyan-500 to-blue-500 bg-clip-text text-transparent mb-4">
                    04
                  </div>
                  <h3 className="font-bold text-gray-900 mb-2">
                   Margin Pressure & Channel Complexity
                  </h3>
                  <p className="text-gray-600">
                    Manage pricing, promotions, and channel margins across modern trade, general trade, and e-commerce.
                  </p>
                </div>

              </div>

              {/* RIGHT SIDE IMAGE */}
              <div className="flex justify-center">
                <img
                  src={ChallengesImage}
                  alt="Challenges"
                  className="rounded-3xl shadow-2xl w-full max-w-xl object-cover"
                />
              </div>

            </div>
          </div>
        </div>
        {/* 🌟 NEW SECTION — How Amplinova turns that challenges into opportunity */}
        <div className="pt-10 pb-20 bg-white">
          <div className="container mx-auto px-6">

            {/* Heading */}
            <h2 className="text-5xl font-bold text-gray-900 text-center mb-16">
              How <span className="bg-gradient-to-r from-cyan-500 to-blue-500 bg-clip-text text-transparent underline decoration-blue-400 decoration-4">Amplinova</span> turns those challenges into opportunities
            </h2>

            {/* 4 Items — Side by side */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-12">

              {/* 01 */}
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-2xl flex items-center justify-center shadow-xl">
                  <FaCheck className="text-white text-3xl" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  End-to-end Traceability
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  From raw-material to retail shelf, maintain batch-level traceability and instant recalls when necessary.
                </p>
              </div>

              {/* 02 */}
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-2xl flex items-center justify-center shadow-xl">
                  <FaCheck className="text-white text-3xl" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Smarter Inventory Management
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Use demand forecasting, automated replenishment, and dynamic safety stocks to lower waste and stockouts.
                </p>
              </div>

              {/* 03 */}
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-2xl flex items-center justify-center shadow-xl">
                  <FaCheck className="text-white text-3xl" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                 Quality & Anti-counterfeit Measures
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Integrate QR/serial verification and automated QC to protect consumers and brand value.
                </p>
              </div>

              {/* 04 */}
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-2xl flex items-center justify-center shadow-xl">
                  <FaCheck className="text-white text-3xl" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Channel Margin & Pricing Optimization
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Centralized pricing rules, promotion engine, and analytics to protect margins across channels.
                </p>
              </div>

            </div>
          </div>
        </div>

        {/* SEGMENTS SECTION */}
        <div className="pt-10 pb-20 bg-white relative">
          <div className="container mx-auto px-6 relative">
            <div className="text-center mb-16">
              <h2 className="text-5xl font-bold text-gray-900 mb-6">
                FMCG Segments We Serve
              </h2>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                Deep expertise across manufacturing, retail, and logistics for FMCG brands
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              {segments.map((segment, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-8 shadow-lg border border-blue-100 hover:shadow-xl transition-all duration-300 group hover:border-blue-300"
                >
                  <div className="bg-gradient-to-r from-cyan-500 to-blue-500 p-4 rounded-2xl inline-flex mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <segment.icon className={`text-2xl ${segment.iconColor}`} />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">
                    {segment.category}
                  </h3>
                  <div className="space-y-3">
                    {segment.items.map((item, itemIndex) => (
                      <div
                        key={itemIndex}
                        className="flex items-center text-gray-700 group/item hover:text-blue-600 transition-colors duration-200"
                      >
                        <div className="bg-green-100 p-1 rounded-lg mr-3 group-hover/item:bg-green-200 transition-colors duration-200">
                          <FaCheck className="text-green-600 text-sm" />
                        </div>
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA SECTION */}
        <div className="relative pt-10 pb-20 bg-gradient-to-br from-gray-900 via-black to-gray-900 overflow-hidden">
          <div className="absolute inset-0 bg-black opacity-40"></div>

          <div className="container mx-auto px-6 text-center relative z-10">
            <h2 className="text-5xl font-bold text-white mb-8">
              Ready to Transform Your FMCG Operations?
            </h2>
            <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto">
              Reduce waste, protect your brand, and scale distribution with modern digital tools tailored for FMCG.
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-6">
              <button
              onClick={() => (window.location.href = "/contact-us")}
              className="bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-12 py-5 rounded-xl font-semibold hover:scale-105 transition flex items-center gap-3">
                Talk to an FMCG Expert
                <FaArrowRight />
              </button>

            </div>
          </div>
        </div>

      </div>

      <Footer />
    </div>
  );
};

export default FMCGIndustry;
